import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";

function Voucher(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.415 3.5a2.447 2.447 0 012.445 2.445v4.794h-1a1.35 1.35 0 00-1.348 1.349 1.35 1.35 0 001.348 1.348h1v4.794a2.448 2.448 0 01-2.445 2.446H2.625A2.448 2.448 0 01.18 18.23v-4.794h1a1.35 1.35 0 001.349-1.348c0-.743-.605-1.349-1.349-1.349h-1V5.945A2.447 2.447 0 012.625 3.5h18.79zm0 2H8.927a1 1 0 01.746.967v1.987a1 1 0 11-2 0V6.467a1 1 0 01.747-.968L2.625 5.5c-.245 0-.445.2-.445.445v2.946a3.358 3.358 0 012.349 3.197c0 1.498-.99 2.769-2.349 3.196v2.946c0 .245.2.446.445.446l5.798.001a1 1 0 01-.75-.968v-1.986a1 1 0 112 0v1.986a1 1 0 01-.75.968l12.492-.001a.447.447 0 00.445-.446v-2.946a3.356 3.356 0 01-2.348-3.196c0-1.498.989-2.77 2.348-3.197V5.945c0-.245-.2-.445-.445-.445zM8.673 10.095a1 1 0 011 1v1.987a1 1 0 11-2 0v-1.987a1 1 0 011-1z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

var MemoVoucher = React.memo(Voucher);
export default MemoVoucher;